import { useState } from 'react';
import { ChevronDown } from 'lucide-react';
import { SEO } from '@/components/SEO';

const FAQ_ITEMS = [
  { q: 'How do I post a dog listing?', a: 'Create an account or sign in, then click "Post Ad" in the navigation bar. Fill in your dog\'s details, upload photos, and submit. Your listing will appear in the marketplace immediately.' },
  { q: 'Is it free to list a dog for sale?', a: 'Yes! Posting basic listings on DoggoHub is completely free. We may offer premium listing features in the future for enhanced visibility.' },
  { q: 'How does the Dog Matcher work?', a: 'Our Dog Matcher uses a questionnaire about your lifestyle, living situation, activity level, and preferences to recommend breeds that would be the best fit for you. It considers factors like apartment compatibility, energy levels, and grooming needs.' },
  { q: 'How can I contact a seller?', a: 'Each listing has a "Contact Seller" button that opens an email with the seller\'s contact information. We recommend meeting in a safe, public location for any transactions.' },
  { q: 'Are the breeders verified?', a: 'While we encourage responsible breeding practices, we recommend doing your own due diligence when purchasing a dog. Ask for health certificates, visit the breeder if possible, and check references.' },
  { q: 'Can I edit or delete my listing?', a: 'Yes! Go to your Dashboard to manage all your listings. You can edit details, update photos, or remove listings at any time.' },
  { q: 'What breeds are covered in the encyclopedia?', a: 'Our Dog Breeds Encyclopedia covers 200+ popular breeds with detailed information about temperament, care needs, compatibility, and more. We regularly add new breeds.' },
];

export default function FAQPage() {
  const [openIndex, setOpenIndex] = useState(null);

  return (
    <div className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8 py-12 animate-fade-in" data-testid="faq-page">
      <SEO
        title="Frequently Asked Questions"
        description="Find answers to common questions about DoggoHub — how to post listings, contact sellers, use the dog matcher, and more."
        keywords="DoggoHub FAQ, dog marketplace help, how to post dog listing, dog matcher help"
      />
      <h1 className="font-['Nunito'] font-extrabold text-3xl sm:text-4xl text-[#1A1D20] tracking-tight mb-2">
        Frequently Asked Questions
      </h1>
      <p className="text-[#5C636A] mb-8">Everything you need to know about DoggoHub</p>

      <div className="space-y-3">
        {FAQ_ITEMS.map((item, i) => (
          <div
            key={i}
            className="bg-white rounded-2xl shadow-[0_8px_30px_rgb(0,0,0,0.04)] overflow-hidden"
            data-testid={`faq-item-${i}`}
          >
            <button
              onClick={() => setOpenIndex(openIndex === i ? null : i)}
              className="w-full flex items-center justify-between p-5 text-left"
              data-testid={`faq-toggle-${i}`}
            >
              <span className="font-semibold text-[#1A1D20] text-sm pr-4">{item.q}</span>
              <ChevronDown className={`w-4 h-4 text-[#5C636A] shrink-0 transition-transform duration-200 ${openIndex === i ? 'rotate-180' : ''}`} />
            </button>
            {openIndex === i && (
              <div className="px-5 pb-5 animate-fade-in">
                <p className="text-sm text-[#5C636A] leading-relaxed">{item.a}</p>
              </div>
            )}
          </div>
        ))}
      </div>
    </div>
  );
}
